import { SidebarAdditionalPackagePayment } from "../shared";
import { SidebarInternationalOffer } from "./SidebarInternationalOffer";

interface ISidebarInternationalProps {
  userFunds: number | undefined;
  hasNoFunds: boolean;
  anniversaryDate: number | undefined;
  productOfferPrice: number;
}

export function SidebarInternational({
  hasNoFunds,
  userFunds,
  anniversaryDate,
  productOfferPrice,
}: ISidebarInternationalProps) {
  return (
    <>
      <SidebarInternationalOffer
        anniversaryDate={anniversaryDate}
        productOfferPrice={productOfferPrice}
        testId="international-package-offer-box"
      />
      <SidebarAdditionalPackagePayment
        hasNoFunds={hasNoFunds}
        productOfferPrice={productOfferPrice}
        testId="international-package-payment-box"
        type="internationalCalls"
        userFunds={userFunds}
      />
    </>
  );
}
